import { SectionHeader } from '@/components/ui/SectionHeader'
import { Reveal } from '@/components/ui/Reveal'
import { SitePhoto } from '@/components/ui/SitePhoto'
import { offerings } from '@/data/training-content'

export const TrainingOfferings = () => (
  <section className="bg-base-50 py-16 sm:py-20 lg:py-24">
    <div className="mx-auto max-w-6xl px-6">
      <SectionHeader title="Education for" accent="every setting" />
      <ul className="grid gap-6 md:grid-cols-3">
        {offerings.map((item, index) => (
          <li key={item.title}>
            <Reveal delay={index * 100} className="h-full">
              <article className="h-full overflow-hidden rounded-3xl border border-base-200 bg-white transition-colors hover:border-green-300">
                <SitePhoto
                  src={item.image}
                  alt={item.title}
                  aspect="aspect-[4/3]"
                  className="rounded-none"
                />
                <div className="p-6">
                  <h3 className="mb-3 font-display text-2xl leading-tight text-base-900">
                    {item.title}
                  </h3>
                  <p className="text-sm leading-6 text-base-600">{item.text}</p>
                </div>
              </article>
            </Reveal>
          </li>
        ))}
      </ul>
    </div>
  </section>
)
